// https://github.com/Sphinxxxx/vanilla-picker/issues/24
// https://jsfiddle.net/9g4nsdz3/2/

import merge from 'lodash-es/merge';
import each from 'lodash-es/each';
import isArray from 'lodash-es/isArray';
import Picker from 'vanilla-picker';
import lookAndFeel from './lookAndFeel';

const settings = {
  layout: 'default',
  alpha: true,
  editor: true,
  editorFormat: 'hex',
  cancelButton: false,
  popup: 'auto',
  defaultColor: '#000000',
};
const picker = new Picker({
  parent: document.body,
});

const placementStyle = document.body.appendChild(document.createElement('style'));

picker.originalOpenHandler = picker.openHandler;
picker.openHandler = function() {};

export default function showColorDialog(e, currentColor, options) {
  return new Promise((resolve) => {
    const clickedElement = e.target;
    options = merge({}, settings, options);
    if (options.color || options.colour) {
      throw new Error('Dont set color in options, use second arg instead.');
    }

    var popups = options.popup;
    if (isArray(popups)) {
      options.popup = options.popup[0];
    } else {
      popups = [popups];
    }

    if (options.popup == 'auto') {
      options.popup = 'right';
      popups = ['right', 'left', 'bottom', 'top'];
    }

    setPosition(popups[0], clickedElement, options.buttonStyle);
    picker.setOptions(options);
    // console.log('setOptions', options);
    picker.setColor(currentColor);
    if(options.onChange){
      picker.onChange = (color) => {
        color.hexOrRgba = () => {
          return color.hex.toLowerCase();          
        };

        options.onChange(color);
      };
    }

    picker.onDone = (color) => {
      color.hexOrRgba = () => {
        return color.hex.toLowerCase();
        // var hexOrRgba = color.hex.toLowerCase();
        // if (_.endsWith(hexOrRgba, 'ff')) {
        //   hexOrRgba = hexOrRgba.substr(0, 7);
        // } else {
        //   hexOrRgba = color.rgbaString;
        // }

        // return hexOrRgba;
      };

      resolve(color);
    };

    picker.originalOpenHandler(e);
    if (!options.alpha) {
      picker.domElement.classList.add('no_alpha');
    } else {
      picker.domElement.classList.remove('no_alpha');
    }

    if (!options.editor) {
      picker.domElement.classList.add('no_editor');
    } else {
      picker.domElement.classList.remove('no_editor');
    }

    if (!options.cancelButton) {
      picker.domElement.classList.add('no_cancel');
    } else {
      picker.domElement.classList.remove('no_cancel');
    }

    autoPosition(popups, options, clickedElement);
  });
}

function setPosition(popup, clickedElement, buttonStyle = lookAndFeel({}, '30.78px')) {
  const bounds = clickedElement.getBoundingClientRect();
  let top, left, translate;
  switch (popup) {
    case 'right':
      left = bounds.right + 15 + window.pageXOffset + 'px';
      top = bounds.bottom - 15 + window.pageYOffset + 'px';
      translate = '0, 0';
      break;
    case 'left':
      left = bounds.left - 45 + window.pageXOffset + 'px';
      top = bounds.bottom - 15 + window.pageYOffset + 'px';
      translate = '-100%, 0';
      break;
    case 'top':
      left = bounds.left - 15 + window.pageXOffset + 'px';
      top = bounds.top - 45 + window.pageYOffset + 'px';
      translate = '0, -100%';
      break;
    case 'bottom':
      left = bounds.left - 15 + window.pageXOffset + 'px';
      top = bounds.bottom + 15 + window.pageYOffset + 'px';
      translate = '0, 0';
      break;
  }

  placementStyle.textContent = `
    .picker_wrapper.popup.popup_${popup} {
      top:  ${top};
      left: ${left};
      transform: translate(${translate});
      bottom: auto;
      right: auto;
      z-index: 500500;
    }

    .picker_wrapper.popup.popup_${popup} button {
      box-sizing: border-box;
      font-size: ${buttonStyle.schemeFontSize};
      font-weight: ${buttonStyle.schemeFontWeight};
      text-align: center;
      background-color: ${buttonStyle.schemeBackground};
      color: ${buttonStyle.schemeForeground};
      border-style: solid;
      border-color: ${buttonStyle.schemeShade};
      border-width: 1px;
      background-image: none;
      box-shadow:0px 2px 4px rgba(0,0,0,0.4), 0 -12px 20px ${buttonStyle.schemeShade} inset,  0 2px 3px #ffffff inset;
    }

    `;
  // console.log('style updated', placementStyle);
}

function autoPosition(popups, options, clickedElement) {
  let pickerBounds = picker.domElement.getBoundingClientRect();
  let bestFit = getPickerFit(pickerBounds);
  if (bestFit == 0) {
    return;
  }

  let bestPopup = options.popup;

  each(popups, (popup) => {
    // console.log('autoPosition', popup);
    if (popup != options.popup) {
      // console.log('switch to new ' + popup + ' position');
      options.popup = popup;
      setPosition(popup, clickedElement, options.buttonStyle);
      picker.setOptions(options);
      // console.log('setOptions', options);
      picker.show();
      pickerBounds = picker.domElement.getBoundingClientRect();
    }

    let fit = getPickerFit(pickerBounds);
    if (fit > bestFit) {
      bestFit = fit;
      bestPopup = popup;
    }

    if (fit == 0) {
      // console.log('picker fits ', fit);
      return false;
    } else {
      // console.log("picker doesn't fit ", fit);
    }
  });
  if (bestFit < 0 && bestPopup !== options.popup) {
    // console.log('finally, best position was', bestPopup, bestFit);
    options.popup = bestPopup;
    setPosition(bestPopup, clickedElement, options.buttonStyle);
    picker.setOptions(options);
    picker.show();
  }
}

function getPickerFit(bounds) {
  return (
    (bounds.top < 0 ? bounds.top : 0) +
    (bounds.right > window.innerWidth ? window.innerWidth - bounds.right : 0) +
    (bounds.bottom > window.innerHeight ? window.innerHeight - bounds.bottom : 0) +
    (bounds.left < 0 ? bounds.left : 0)
  );
}
